import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api`;

const fetchAllStatesApi = async () => {
  const response = await axios.get(`${API_BASE_URL}/states`);
  return response;
};

const fetchAllCompanyTypesApi = async () => {
  const response = await axios.get(`${API_BASE_URL}/companyType`);
  return response;
};

const fetchAllRolesApi = async () => {
  const response = await axios.get(`${API_BASE_URL}/roles`);
  return response;
};

export { fetchAllCompanyTypesApi, fetchAllRolesApi, fetchAllStatesApi };
